import jwtDecode from "jwt-decode";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { currencyToNumber } from "../../../../helpers/functions/currencyFormater";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import taService from "../services/ta.service";
import Collapse from "bootstrap/js/dist/collapse";

export default function useOnboardingWorkflow(active = {}) {
  const { Userdata = {}, id, taOnboardingCaseId } = active;
  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();
  const initialUpload = {
    aadhar_front: "",
    aadhar_back: "",
    pan: "",
    firm_pan: "",
    passport_photo: "",
    business_proof_1: "",
    business_proof_2: "",
    ksos_cheque_1: "",
    ksos_cheque_2: "",
    tyger_cheque_1: "",
    tyger_cheque_2: "",
    bank_statement: "",
    itr_year_1: "",
    itr_year_2: "",
    partnership_deed: "",
  };

  const [formUpload, setFormUpload] = useState(initialUpload);
  const initialValues = {
    taOnboardingCaseId: "",
    businessType: "",
    businessExperienceYears: "",
    noOfPartners: 0,
    companyName: "",
    taUserPhone: Userdata?.phone,
    personName: Userdata?.userName,
    officeType: "",
    yardDetails: "",
    email: "",
    companyAddress: "",
    vintageWithMeratractorYears: "",
    monthlyAverageSalesUnit: "",
    maritalStatusOfApplicant: "",
    residenceType: "",
    residentialStabilityYears: "",
    monthlyAverageSalesVolume: "",
    reference1Name: "",
    reference1Phone: "",
    reference2Name: "",
    reference2Phone: "",
    brokerBackground: "",
    dealingInList: "",
    financiers: "",
    yardForStocking: "",
    userPan: Userdata?.pan,
    associatedFinanciers: "",
    businessProof1Name: Userdata?.businessProof1Name,
    businessProof2Name: Userdata?.businessProof2Name,
    state: Userdata?.state_name,
    dealingInTractor: false,
    dealingInCv: false,
    dealingIn2w: false,
  };

  const statusCodeBySHOrBA = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
    { label: "All", value: "all" },
  ];
  const statusCodeByRISKORSA = [
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" },
  ];
  let option = [];

  if (
    user?.role === "Auction Representative" ||
    user?.role === "Business Analyst"
  ) {
    option = statusCodeBySHOrBA;
  } else if (
    user?.role === "Super Admin" ||
    user?.role === "Developer" ||
    user?.role === "Head - Risk And Process"
  ) {
    option = statusCodeByRISKORSA;
  }

  // Default to "All" where the role has it (AR and BA). Pending hides every case
  // that reached limit setting, so a Limit Expiry filter applied on the default
  // queue would come back empty. Risk/SA have no "all" option — they keep
  // whichever queue their list starts with.
  const [statusCode, setStatusCode] = useState(
    option.find((o) => o.value === "all")?.value ?? option[0]?.value,
  );
  const [formData, setFormData] = useState(initialValues);
  const [selected, setSelected] = useState("buss");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [userModal, setUserModal] = useState(false);
  const [documentUploadProgress, setDocumentUploadProgress] = useState(0);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingbusDetails, setLoadingbusDetails] = useState(false);
  const [loadingTADetails, setLoadingTADetails] = useState(true);
  const [taUserDetails, setTAUserDetails] = useState("");
  const [filterTAUserDetails, setFilterTAUserDetails] = useState("");
  const [taUserData, setTAUserData] = useState("");
  const [TAUserList, setTAUserList] = useState("");
  const [ID, setId] = useState();
  const [businessProofSelections, setBusinessProofSelections] = useState({
    businessProof1Name: Userdata?.businessProof1Name,
    businessProof2Name: Userdata?.businessProof2Name,
    itrYear1Available: Userdata?.itrYear1Available === true ? "Yes" : "No",
    itrYear2Available: Userdata?.itrYear2Available === true ? "Yes" : "No",
  });
  const [debounceVal, setDebounceVal] = useState("");
  const [modalForUpdateLimit, setModalForUpdateLimit] = useState(false);
  const [modalAddComment, setModalAddComment] = useState(false);
  const [modalAddCommentData, setModalAddCommentData] = useState("");
  const [modalForUpdateLimitData, setModalForUpdateLimitData] = useState("");

  useEffect(() => {
    if (id) {
      setId(id);
    } else if (taOnboardingCaseId) {
      setId(taOnboardingCaseId);
    }
  }, [id, taOnboardingCaseId]);

  const handleChangebussDetails = (e, name, type) => {
    if (e?.target) {
      const { name, value } = e.target;
      if (name === "dealingInList") {
        setFormData((prevData) => {
          const normalizedValues = (value || []).map((v) => v.toLowerCase());

          return {
            ...prevData,
            [name]: value,
            dealingInCv: normalizedValues.includes("cv") ? "True" : "False",
            dealingInTractor: normalizedValues.includes("tractor")
              ? "True"
              : "False",
            dealingIn2w:
              normalizedValues.includes("2w") ||
              normalizedValues.includes("2 wheeler")
                ? "True"
                : "False",
          };
        });
      } else if (name === "noOfPartners") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value !== "" ? parseInt(value) : "",
        }));
      } else if (name.startsWith("partner_")) {
        const [, index, field] = name.split("_");
        setFormData((prevData) => {
          const updatedPartners = [...prevData.partnerDetails];
          updatedPartners[Number(index) - 1] = {
            ...updatedPartners[Number(index) - 1],
            [field]: value?.trimStart(),
          };

          return { ...prevData, partnerDetails: updatedPartners };
        });
      } else if (name === "monthlyAverageSalesVolume") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: currencyToNumber(value),
        }));
      } else if (name === "businessType") {
        if (value === "Partnership" || value === "Private limited (Pvt Ltd)") {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value?.trimStart(),
            partnerDetails: [
              {
                personName: "",
                phone: "",
                email: "",
                residenceType: "",
                businessExperienceYears: "",
                maritalStatusOfApplicant: "",
              },
            ],
          }));
        } else {
          setFormData((prevData) => ({
            ...prevData,
            [name]: value?.trimStart(),
          }));
        }
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value?.trimStart(),
        }));
      }
    } else if (e && name?.name) {
      const fieldName = name.name;

      const value = name?.isMulti ? e.map((opt) => opt.value) : e.value;

      setFormData((prevData) => ({
        ...prevData,
        [fieldName]: value?.trimStart(),
      }));
    }
  };

  const handleUpload = async (e, name, docId, id, isRequired, header) => {
    try {
      const file = e.target.files?.[0];
      if (!file) return;

      const caseId = id || taOnboardingCaseId;
      if (!caseId) {
        errorToast("Please update business details first");
        return;
      }

      const fileURL = URL.createObjectURL(file);
      const fileType = file.type;
      let filePreviewHTML = "";
      if (fileType === "application/pdf") {
        filePreviewHTML = `<iframe src="${fileURL}" width="100%" height="400px" style="border:1px solid #ccc;"></iframe>`;
      } else if (fileType.startsWith("image/")) {
        filePreviewHTML = `<img src="${fileURL}" style="max-width:100%; max-height:400px; border:1px solid #ccc;" />`;
      } else if (
        file.name.endsWith(".doc") ||
        file.name.endsWith(".docx") ||
        fileType === "application/msword" ||
        fileType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        filePreviewHTML = `<p><a href="${fileURL}" target="_blank">Click here to preview the DOC file</a></p>`;
      } else {
        filePreviewHTML = `<p>File preview not supported. Click "Upload" to continue.</p>`;
      }
      const result = await Swal.fire({
        title: "Confirm Upload",
        html: `
          <p>You are about to upload: <strong>${file.name} for ${header}</strong></p>
          ${filePreviewHTML}
        `,
        showCancelButton: true,
        confirmButtonText: "Yes, Upload it!",
        cancelButtonText: "Cancel",
        width: 600,
        heightAuto: false,
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("taOnboardingCaseId", caseId);
          formData.append(name, file);

          try {
            const response = await taService.UploadDoc(formData);
            if (response?.status === 200) {
              const updatedDocuments = taUserDetails.documents.map((item) =>
                item.documentName === name
                  ? {
                      ...item,
                      documentID: response?.documentId,
                      documentPath: response?.link,
                      isUploaded: true,
                      isRejected: false,
                      isApproved: response?.isApproved,
                      rejectionRemarks: "",
                    }
                  : item
              );
              setTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                rejected: response.rejected,
                missing: response.missing,
                pending: response.pending,
                verified: response.verified,
                totalDoc: response.totalDoc,
              }));

              setFilterTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                rejected: response.rejected,
                missing: response.missing,
                pending: response.pending,
                verified: response.verified,
                totalDoc: response.totalDoc,
              }));
            } else {
              errorToast(response?.msg);
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
      });

      if (!result.isConfirmed || !result.value) {
        e.target.value = null;
        URL.revokeObjectURL(fileURL);
        return;
      }

      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Upload error:", error);
      errorToast("An error occurred during upload.");
    }
  };

  const handleVerifiedrRejected = async (
    e,
    id,
    docId,
    status,
    field,
    header
  ) => {
    if (status === "approve") {
      const inputValue = data;
      const auctionText = `You want to Verify ${header}`;
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Approve it!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("taOnboardingCaseId", id);
          formData.append("documentId", docId);
          formData.append("status", status);
          try {
            const response = await taService.VerifyOrRejectDocumentsByBA(
              formData
            );
            if (response?.status === 200) {
              successToast(response?.msg);
              const updatedDocuments = taUserDetails.documents.map((item) => {
                if (item.documentID === docId) {
                  return {
                    ...item,
                    isUploaded: true,
                    isRejected: false,
                    isApproved: true,
                    rejectionRemarks: "",
                  };
                }
                return item;
              });

              setTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                pending: prev?.pending - 1,
                verified: prev?.verified + 1,
              }));

              setFilterTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                pending: prev?.pending - 1,
                verified: prev?.verified + 1,
              }));
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    } else {
      const inputValue = data;
      const auctionText = `You want to Reject ${header}`;
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        inputLabel: "Rejection Reason",
        input: "text",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reject it!",
        showLoaderOnConfirm: true,
        preConfirm: async (rejectionReason) => {
          if (!rejectionReason) {
            Swal.showValidationMessage("Rejection reason is required");
            return false;
          }
          const formData = new FormData();
          formData.append("taOnboardingCaseId", id);
          formData.append("documentId", docId);
          formData.append("status", status);
          formData.append("rejectionRemarks", rejectionReason);

          try {
            const response = await taService.VerifyOrRejectDocumentsByBA(
              formData
            );

            if (response?.status === 200) {
              successToast(response?.data);
              const updatedDocuments = taUserDetails.documents.map((item) => {
                if (item.documentID === docId) {
                  return {
                    ...item,
                    isUploaded: true,
                    isRejected: true,
                    isApproved: false,
                    rejectionRemarks: rejectionReason,
                  };
                }
                return item;
              });

              setFilterTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                pending: prev?.pending - 1,
                rejected: prev?.rejected + 1,
              }));
              setTAUserDetails((prev) => ({
                ...prev,
                documents: updatedDocuments,
                pending: prev?.pending - 1,
                rejected: prev?.rejected + 1,
              }));
            } else {
              errorToast(response?.msg);
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    }
  };

  const handleVerifiedrRejectedBusDetails = async (e, id, status) => {
    if (status === "approve") {
      setLoadingbusDetails(true);
      const formData = new FormData();
      formData.append("taOnboardingCaseId", id);
      formData.append("status", status);
      const response = await taService.VerifyOrRejectBusDetailsByBA(formData);

      if (response?.status === 200) {
        setLoadingbusDetails(false);
        successToast(response?.msg);
        const updatedDocuments = {
          ...taUserDetails,
          documentID: response?.documentID,
          isCaseBusinessDetailsApprovedByBa: true,
        };
        setTAUserDetails(updatedDocuments);
        setFilterTAUserDetails(updatedDocuments);
      } else {
        setLoadingbusDetails(false);
        errorToast(response?.msg);
      }
    } else {
      const inputValue = data;
      const auctionText = "You want to Reject  ";
      Swal.fire({
        title: "Are you sure?",
        html: auctionText,
        icon: "warning",
        showCancelButton: true,
        inputLabel: "Rejection Reason",
        input: "text",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Reject it!",
        showLoaderOnConfirm: true,
        preConfirm: async (rejectionReason) => {
          if (!rejectionReason) {
            Swal.showValidationMessage("Rejection reason is required");
            return false;
          }

          const formData = new FormData();
          formData.append("taOnboardingCaseId", id);
          formData.append("status", status);
          formData.append("rejectionRemarks", rejectionReason);

          try {
            const response = await taService.VerifyOrRejectBusDetailsByBA(
              formData
            );
            setLoadingbusDetails(false);
            if (response?.status === 200) {
              successToast(response?.data);
              const updatedDocuments = {
                ...taUserDetails,
                documentID: response?.documentID,
                isCaseBusinessDetailsRejectedByBa: true,
                caseBusinessDetailsRejectionReason: rejectionReason,
              };

              setTAUserDetails(updatedDocuments);
              setFilterTAUserDetails(updatedDocuments);
            } else {
              errorToast(response?.msg);
            }
          } catch (error) {
            Swal.showValidationMessage(`Request failed: ${error}`);
          }
        },
      });
    }
  };

  const handleVerifyAll = async (e, id, status) => {
    const formData = new FormData();
    formData.append("taOnboardingCaseId", id);
    const response = await taService.VerifyCaseByBA(formData);
    if (response?.status === 200) {
      successToast(response?.msg);
      const updatedDocuments = {
        ...taUserDetails,
        isCaseBusinessDetailsApprovedByBa: true,
      };
      setTAUserDetails(updatedDocuments);
      setFilterTAUserDetails(updatedDocuments);
      window.location.reload();
    } else {
      errorToast(response?.msg);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = e.target;
      if (!form.checkValidity()) {
        // Find the first invalid field
        const firstInvalid = form.querySelector(":invalid");
        if (firstInvalid) {
          // Find the closest accordion section

          const accordionItem = firstInvalid.closest(".accordion-item");

          if (accordionItem) {
            // Get the collapse target ID

            const collapse = accordionItem.querySelector(".accordion-collapse");

            if (collapse && collapse.id) {
              const bsCollapse = Collapse.getOrCreateInstance(collapse);

              bsCollapse.show();
              // Optionally, focus the invalid field
              firstInvalid.focus();
            }
          }
        }
        // Let browser show validation messages

        form.reportValidity();
        return;
      }

      if (
        (formData?.businessType === "partnership" ||
          formData?.businessType === "pvt_ltd") &&
        formData?.noOfPartners === 0 &&
        formData?.partnerDetails.length === 0
      ) {
        errorToast("At least 1 partner is required");
        return;
      }
      if (formData?.dealingInList.length > 0) {
        e.preventDefault();
        let newFormData = {};
        if (
          formData?.taOnboardingCaseId !== "" ||
          formData?.taOnboardingCaseId !== undefined
        ) {
          newFormData = {
            taOnboardingCaseId: formData?.taOnboardingCaseId
              ? formData?.taOnboardingCaseId
              : "",
            ...(["individual", "proprietor"].includes(formData?.businessType)
              ? { pan: formData?.userPan }
              : { firmPan: formData?.firmPan }),
            businessType: formData.businessType,

            noOfPartners:
              formData?.partnerDetails?.length > 0
                ? formData?.partnerDetails?.length || 0
                : 0,
            businessExperienceYears: formData?.businessExperienceYears,
            companyName:
              ["proprietor", "partnership", "pvt_ltd"].includes(
                formData?.businessType
              ) && formData?.companyName,
            taUserPhone: formData?.taUserPhone,
            maritalStatusOfApplicant: formData?.maritalStatusOfApplicant,
            email: formData?.email,
            personName: formData?.personName,
            residenceType: formData?.residenceType,
            officeType: formData?.officeType,
            yardDetails: formData?.yardDetails,
            vintageWithMeratractorYears: formData?.vintageWithMeratractorYears,
            monthlyAverageSalesUnit: formData?.monthlyAverageSalesUnit,
            monthlyAverageSalesVolume: formData?.monthlyAverageSalesVolume,
            reference1Name: formData?.reference1Name,
            reference1Phone: formData?.reference1Phone,
            reference2Name: formData?.reference2Name,
            reference2Phone: formData?.reference2Phone,
            brokerBackground: formData?.brokerBackground,
            dealingInList: formData?.dealingInList,
            yardForStocking: formData?.yardForStocking,
            businessProof1Name: formData?.businessProof1Name,
            businessProof2Name: formData?.businessProof2Name,
            associatedFinanciers: formData?.associatedFinanciers,
            residentialStabilityYears: formData?.residentialStabilityYears,
            dealingIn2w: formData?.dealingIn2w,
            dealingInCv: formData?.dealingInCv,
            dealingInTractor: formData?.dealingInTractor,
            companyAddress: formData?.companyAddress,
            ...(["partnership", "pvt_ltd"].includes(formData?.businessType) && {
              partnerDetails: formData?.partnerDetails,
              noOfPartners: formData?.noOfPartners,
            }),
          };
        } else {
          newFormData = {
            pan: ["partnership", "pvt_ltd"].includes(formData?.businessType)
              ? formData?.firmPan
              : formData?.userPan,
            businessType: formData.businessType,
            partnerDetails:
              ["partnership", "pvt_ltd"].includes(formData?.businessType) &&
              formData?.partnerDetails,
            businessExperienceYears: formData?.businessExperienceYears,
            noOfPartners:
              formData?.partnerDetails?.length > 0
                ? formData?.partnerDetails?.length || 0
                : 0,
            companyName:
              ["proprietor", "partnership", "pvt_ltd"].includes(
                formData?.businessType
              ) && formData?.companyName,
            taUserPhone: formData?.taUserPhone,
            email: formData?.email,
            personName: formData?.personName,
            residenceType: formData?.residenceType,
            maritalStatusOfApplicant: formData?.maritalStatusOfApplicant,
            officeType: formData?.officeType,
            yardDetails: formData?.yardDetails,
            companyAddress: formData?.companyAddress,
            vintageWithMeratractorYears: formData?.vintageWithMeratractorYears,
            monthlyAverageSalesUnit: formData?.monthlyAverageSalesUnit,
            monthlyAverageSalesVolume: formData?.monthlyAverageSalesVolume,
            reference1Name: formData?.reference1Name,
            reference1Phone: formData?.reference1Phone,
            reference2Name: formData?.reference2Name,
            reference2Phone: formData?.reference2Phone,
            brokerBackground: formData?.brokerBackground,
            yardForStocking: formData?.yardForStocking,
            associatedFinanciers: formData?.associatedFinanciers,
            residentialStabilityYears: formData?.residentialStabilityYears,
            dealingIn2w: formData?.dealingIn2w,
            dealingInCv: formData?.dealingInCv,
            dealingInTractor: formData?.dealingInTractor,
          };
        }

        let response = "";

        setButtonLoader(true);
        if (taOnboardingCaseId && taOnboardingCaseId !== "") {
          response = await taService.UpdateTAUser(newFormData);
        } else {
          response = await taService.CreateTAUser(newFormData);
        }
        setButtonLoader(false);
        if (response && response.status === 200) {
          successToast(response.msg);
          setLoadingTADetails(true);
          const formData = new FormData();
          if (taOnboardingCaseId && taOnboardingCaseId !== "") {
            formData.append("taOnboardingCaseId", taOnboardingCaseId);
          } else {
            formData.append("taOnboardingCaseId", response?.taOnboardingCaseId);
          }
          const res = await taService.GetTACaseDetails(formData);
          if (res?.status === 200) {
            setLoadingTADetails(false);
            setTAUserDetails(res.data);
            setFilterTAUserDetails(res.data);
            setFormData((prev) => ({
              ...prev,
              ...res.data,
            }));
            setFormUpload(res?.data?.documents);
            if (taOnboardingCaseId && taOnboardingCaseId !== "") {
              history.push(
                `/auction_representative/user_home/manage-ta-onboard-id:${taOnboardingCaseId}`
              );
            } else {
              history.push(
                `/auction_representative/user_home/manage-ta-onboard-id:${response?.taOnboardingCaseId}`
              );
            }
          } else {
            setLoadingTADetails(false);
            errorToast(res?.msg);
          }
        } else {
          errorToast(response.msg);
        }
      } else {
        errorToast(
          "before submit the form please select Dealing In (Vehicle category) "
        );
      }
    } catch (error) {
      console.error(error);

      errorToast(error?.message);
    }
  };

  const handleSelectedUserConformation = async (e) => {
    if (!taUserData?.is_user_channel_financed) {
      history.push({
        pathname:
          "/auction_representative/user_home/manage-ta-onboard/create-ta-user",
        state: { data: taUserData },
      });
      setButtonLoader(false);
    } else {
      errorToast(
        "This is TA User please select another user to create TA user"
      );
    }
  };

  const handleSelect = (e) => {
    setTAUserData(e.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const value = ["AB"];
        const formData = new FormData();
        formData.append("shorthandsList", JSON.stringify(value));
        const response = await taService.GetUserList(formData);
        if (response?.status === 200) {
          const TA_user_list = response?.data.map((val) => ({
            label: `${val?.phone}  (${val?.userName} ${
              val?.is_user_channel_financed ? "-  TA User" : ""
            })`,
            value: val,
          }));
          setTAUserList(TA_user_list);
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (user?.role === "Auction Representative") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUser(formData);

          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (user?.role === "Business Analyst") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserByBA(formData);
          if (response?.status === 200) {
            const updatedResponse = response?.data?.map((value) => ({
              ...value,
              ["stage"]: value?.isLimitSettingAllDocumentUploaded
                ? "Limit setting Email"
                : value?.isLosApplicationIdUpdated
                ? "Limit setting Document Upload"
                : value?.isCaseApprovedByBa
                ? "LOS Updation"
                : "Business Document Verification",
            }));
            setLoading(false);
            // setFilterData(response?.data);
            // setData(response?.data);
            setFilterData(updatedResponse);
            setData(updatedResponse);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (user?.role === "Super Admin" || user?.role === "Developer") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserBySA(formData);
          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        } else if (user?.role === "Head - Risk And Process") {
          const formData = new FormData();
          formData.append("caseStatus", statusCode);
          const response = await taService.GetAllTAUserByRisk(formData);
          if (response?.status === 200) {
            setLoading(false);
            setFilterData(response?.data);
            setData(response?.data);
          } else {
            setLoading(false);
            errorToast(response?.msg);
          }
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
        setLoading(false);
      }
    };

    fetchData();
  }, [statusCode]);

  const handleViewDetails = (val) => {
    if (
      val?.isCaseBusinessDetailsRejectedByBa &&
      user?.role === "Auction Representative"
    ) {
      history.push({
        pathname: `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${val?.taOnboardingCaseId}`,
        state: { value: val?.taOnboardingCaseId, data: val },
      });
    } else {
      history.push({
        pathname: `/auction_representative/user_home/manage-ta-onboard-id:${val?.taOnboardingCaseId}`,
        state: { value: val?.taOnboardingCaseId, data: val },
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingTADetails(true);
        const formData = new FormData();
        formData.append("taOnboardingCaseId", ID);
        const response = await taService.GetTACaseDetails(formData);
        if (response?.status === 200) {
          if (
            response?.data?.isCaseBusinessDetailsRejectedByBa &&
            user?.role === "Auction Representative"
          ) {
            history?.push(
              `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${response?.data?.taOnboardingCaseId}`
            );
            setTAUserDetails(response.data);
            const businessTypeMap = {
              individual: "Individual",
              proprietor: "Proprietor",
              partnership: "Partnership",
              pvt_ltd: "Private limited (Pvt Ltd)",
            };
            const dealingInListMap = {
              CV: "cv",
              Tractor: "tractor",
              "2 Wheeler": "2w",
            };
            const capitalizeWords = (str) =>
              str
                ?.toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

            const normalizedDealingInList = (
              response.data.dealingInList || []
            ).map((item) => {
              const trimmed = item?.trim().toLowerCase();

              return dealingInListMap[trimmed] || capitalizeWords(trimmed);
            });
            setFilterTAUserDetails({
              ...response.data,
              userPan: response?.data?.pan,
              businessType:
                businessTypeMap[response.data.businessType] ||
                response.data.businessType,

              // dealingInList: normalizedDealingInList,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });

            setFormData((prev) => ({
              ...prev,
              ...response.data,
              userPan: response?.data?.pan,
              // businessType:
              //   businessTypeMap[response.data.businessType] ||
              //   response.data.businessType,

              // dealingInList: normalizedDealingInList,
            }));
            setFormUpload(response?.data?.documents);
            setBusinessProofSelections({
              bankStatementPassword: response?.data?.bankStatementPassword,
              businessProof1Name: response?.data?.businessProof1Name,
              businessProof2Name: response?.data?.businessProof2Name,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });
            setLoadingTADetails(false);
          } else {
            setTAUserDetails(response.data);
            const businessTypeMap = {
              individual: "Individual",
              proprietor: "Proprietor",
              partnership: "Partnership",
              pvt_ltd: "Private limited (Pvt Ltd)",
            };

            setFilterTAUserDetails({
              ...response.data,
              userPan: response?.data?.pan,
              businessType:
                businessTypeMap[response.data.businessType] ||
                response.data.businessType,
              // dealingInList: normalizedDealingInList,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });

            setFormData((prev) => ({
              ...prev,
              ...response.data,
              userPan: response?.data?.pan,
              // businessType:
              //   businessTypeMap[response.data.businessType] ||
              //   response.data.businessType,
              // dealingInList: normalizedDealingInList,
            }));
            setFormUpload(response?.data?.documents);
            setBusinessProofSelections({
              bankStatementPassword: response?.data?.bankStatementPassword,
              businessProof1Name: response?.data?.businessProof1Name,
              businessProof2Name: response?.data?.businessProof2Name,
              itrYear1Available:
                response?.data?.itrYear1Available === true ? "Yes" : "No",
              itrYear2Available:
                response?.data?.itrYear2Available === true ? "Yes" : "No",
            });
            setLoadingTADetails(false);
          }
        } else {
          setLoadingTADetails(false);
          errorToast(response?.msg);
        }
      } catch (error) {
        errorToast(error?.msg || "Something went wrong");
        setLoadingTADetails(false);
      }
    };

    if (ID) {
      fetchData();
    }
  }, [ID]);

  const handleSelectStatusCode = (e) => {
    setStatusCode(e.value);
  };

  const handleBusinessProofChange = async (selected, key) => {
    let newSelection;
    const formData = new FormData();
    if (key === "itrYear1Available" || key === "itrYear2Available") {
      if (selected === "Yes") {
        newSelection = {
          ...businessProofSelections,
          [key]: true,
        };
      } else if (selected === "No") {
        newSelection = {
          ...businessProofSelections,
          [key]: false,
        };
      }
    } else {
      newSelection = {
        ...businessProofSelections,
        [key]: selected,
      };
    }

    formData.append(key, newSelection[key]);
    formData.append("taOnboardingCaseId", ID);
    const response = await taService.GlobalUpdateTaCaseField(formData);
    if (response?.status === 200) {
      setBusinessProofSelections((prev) => ({ ...prev, [key]: selected }));

      setFilterTAUserDetails((...prev) => ({
        ...prev[0],
        [key]: selected,
      }));
    } else {
      errorToast(response?.msg);
    }
  };

  useEffect(() => {
    const updateBusinessProof = async () => {
      if (debounceVal !== "") {
        try {
          const formData = new FormData();
          formData.append("bankStatementPassword", debounceVal);
          formData.append("taOnboardingCaseId", ID);

          const response = await taService.GlobalUpdateTaCaseField(formData);
          if (response?.status === 200) {
            setBusinessProofSelections((prev) => ({
              ...prev,
              ["bankStatementPassword"]: debounceVal,
            }));
          } else {
            errorToast(response?.msg);
          }
        } catch (error) {
          errorToast(error?.message || "Something went wrong");
        }
      }
    };

    updateBusinessProof();
  }, [debounceVal]);

  function debounce(cb, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const debouncedChange = useCallback(
    debounce((inputValue) => {
      setDebounceVal(inputValue);
    }, 900),
    []
  );

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    debouncedChange(value);
    setFilterTAUserDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeletePartner = async (e, id, partnerID) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this partner's details?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();
          formData.append("partnerId", partnerID);
          formData.append("taOnboardingCaseId", id);

          try {
            const response = await taService.DeletePartnerById(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              setLoadingTADetails(true);
              const formData = new FormData();
              formData.append("taOnboardingCaseId", id);
              const res = await taService.GetTACaseDetails(formData);
              if (res?.status === 200) {
                const businessTypeMap = {
                  individual: "Individual",
                  proprietor: "Proprietor",
                  partnership: "Partnership",
                  pvt_ltd: "Private limited (Pvt Ltd",
                };
                const dealingInListMap = {
                  CV: "cv",
                  Tractor: "tractor",
                  "2 Wheeler": "2w",
                };

                setTAUserDetails(res.data);
                // setFilterTAUserDetails(res.data);
                // setFormData((prev) => ({
                //   ...prev,
                //   ...res.data,
                //   ["noOfPartners"]: res?.data?.noOfPartners,
                // }));

                setFilterTAUserDetails({
                  ...res?.data,
                  businessType:
                    businessTypeMap[res?.data.businessType] ||
                    res?.data.businessType,
                  dealingInList:
                    dealingInListMap[res?.data.dealingInList] ||
                    res?.data.dealingInList,
                });

                setFormData((prev) => ({
                  ...prev,
                  ...res?.data,
                  // businessType:
                  //   businessTypeMap[res?.data.businessType] ||
                  //   res?.data.businessType,
                  // dealingInList:
                  //   dealingInListMap[res?.data.dealingInList] ||
                  //   res?.data.dealingInList,
                }));
                setFormUpload(res?.data?.documents);
                setBusinessProofSelections({
                  bankStatementPassword: res?.data?.bankStatementPassword,
                  businessProof1Name: res?.data?.businessProof1Name,
                  businessProof2Name: res?.data?.businessProof2Name,
                  itrYear1Available:
                    res?.data?.itrYear1Available === true ? "Yes" : "No",
                  itrYear2Available:
                    res?.data?.itrYear2Available === true ? "Yes" : "No",
                });
                setLoadingTADetails(false);
              } else {
                setLoadingTADetails(false);
                errorToast(res?.msg);
              }
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.error("Error deleting partner:", error);
      errorToast("An error occurred while deleting the partner.");
    }
  };
  const handleDeleteCase = async (e, id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this case?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        focusCancel: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const formData = new FormData();

          formData.append("taOnboardingCaseId", id);

          try {
            const response = await taService.DeleteTACase(formData);
            if (response?.status === 200) {
              successToast(response?.msg);
              history.push(
                `/business_analyst:${user?.phone}&state=${user?.state}`
              );
            }
          } catch (err) {
            Swal.showValidationMessage(err.message);
            throw err;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.error("Error deleting partner:", error);
      errorToast("An error occurred while deleting the partner.");
    }
  };

  const handleSendEmail = (value) => {
    const emailData = {
      to: "",
      cc: "",
      subject: `CF - KSOS - Limit Setting - ${value?.personName}`,
      body: `Hi,
  
  Please find attached new limit Setting documents for  ${value?.personName}.
  
  Pls confirm once limit setting done with details.
  
  Regards,
  Sachin`,
    };

    openOutlookEmail(emailData);
  };

  const openOutlookEmail = ({ to, cc, subject, body }) => {
    const mailtoLink = `mailto:${encodeURIComponent(
      to
    )}?cc=${encodeURIComponent(cc)}&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleConformEmail = async (value) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning", // Changed to warning for confirmation dialogs
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Mark as Sent!",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(), // Prevent closing while loading
        preConfirm: async () => {
          try {
            const formData = new FormData();
            formData.append("taOnboardingCaseId", value?.taOnboardingCaseId);
            const response = await taService.ConformMailsend(formData);

            if (response?.status === 200) {
              return response; // This will resolve Swal.fire with `result.value = response`
            } else {
              throw new Error(response?.msg || "Failed to send email");
            }
          } catch (err) {
            Swal.showValidationMessage(`Request failed: ${err.message}`);
            return false;
          }
        },
      });

      if (result.isConfirmed && result.value) {
        const response = result.value;
        successToast(response?.msg);
        await Swal.fire({
          title: "Email Sent!",
          text: "Email Marked as Sent Successfully!.",
          icon: "success",
        });
        window.location.reload();
      }
    } catch (error) {
      console.error("Error sending confirmation email:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while sending the email.",
        icon: "error",
      });
    }
  };

  return {
    selected,
    setSelected,
    formData,
    setFormData,
    buttonLoader,
    setButtonLoader,
    handleChangebussDetails,
    handleSubmit,
    handleUpload,
    formUpload,
    setFormUpload,
    documentUploadProgress,
    setDocumentUploadProgress,
    data,
    setData,
    filterData,
    setFilterData,
    modal,
    setModal,
    userModal,
    setUserModal,
    taUserData,
    setTAUserData,
    TAUserList,
    setTAUserList,
    handleSelectedUserConformation,
    handleSelect,
    loading,
    handleViewDetails,
    setTAUserDetails,
    setFilterTAUserDetails,
    filterTAUserDetails,
    taUserDetails,
    setLoadingTADetails,
    loadingTADetails,
    handleVerifiedrRejected,
    handleVerifiedrRejectedBusDetails,
    handleVerifyAll,
    modalData,
    setModalData,
    option,
    handleSelectStatusCode,
    statusCode,
    loadingbusDetails,
    businessProofSelections,
    setBusinessProofSelections,
    handleBusinessProofChange,
    handleChangePassword,
    handleDeletePartner,
    handleSendEmail,
    openOutlookEmail,
    handleConformEmail,
    modalForUpdateLimit,
    setModalForUpdateLimit,
    modalAddComment,
    setModalAddComment,
    modalAddCommentData,
    setModalAddCommentData,
    modalForUpdateLimitData,
    setModalForUpdateLimitData,
    handleDeleteCase,
  };
}
